var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("query: "+_vm._s(_vm.$route.query))]),_c('p',[_vm._v("params: "+_vm._s(_vm.$route.params))])])
}
var staticRenderFns = []

export { render, staticRenderFns }